/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Buy_Messages_Modal_Custom_Price_Per_MessageInputs */

const es_components_buy_messages_modal_custom_price_per_message = /** @type {(inputs: Components_Buy_Messages_Modal_Custom_Price_Per_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` por mensaje`)
};

const en_components_buy_messages_modal_custom_price_per_message = /** @type {(inputs: Components_Buy_Messages_Modal_Custom_Price_Per_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` per message`)
};

/**
* | output |
* | --- |
* | "per message" |
*
* @param {Components_Buy_Messages_Modal_Custom_Price_Per_MessageInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_buy_messages_modal_custom_price_per_message = /** @type {((inputs?: Components_Buy_Messages_Modal_Custom_Price_Per_MessageInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Buy_Messages_Modal_Custom_Price_Per_MessageInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_buy_messages_modal_custom_price_per_message(inputs)
	return en_components_buy_messages_modal_custom_price_per_message(inputs)
});
export { components_buy_messages_modal_custom_price_per_message as "components.buy_messages_modal.custom.price_per_message" }